import { render } from "./PrivacyHeader.vue?vue&type=template&id=40d82a6f&scoped=true"
import script from "./PrivacyHeader.vue?vue&type=script&lang=js"
export * from "./PrivacyHeader.vue?vue&type=script&lang=js"

import "./PrivacyHeader.vue?vue&type=style&index=0&id=40d82a6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d82a6f"]])

export default __exports__